import React, { useState } from "react";
import "./MediaSection.css";



const mediaItems = [
  // {
  //   title: "V3G Films",
  //   text: `V3G Films showcases the creative talents of students and faculty in filmmaking and visual storytelling, providing a platform for innovative media projects.`,
  //   image: "/images/media/v3g_films.jpg",
  //   link: "#",
  // },
  {
    title: "Aajkaal.in",
    text: `A real-time, online news portal catering to the Bengali diaspora, up its sleeve, makes TIG
stand out in its media endeavours. Aajkaal comes with the rich legacy of more than four
decades, having served as an important mouthpiece of the Bengali readers, while also
having a very decorated publication.  ​`,
    image: "/images/media/ajkaal.jpg",
    link: "https://www.aajkaal.in/",
  },
  {
    title: "DaakBangla.com",
    text: `Wherever you are on this planet, if you possess a keen interest in Bengali literature,
culture and everything that is associated with the Bengali identity then this new-age
portal has got you covered. ​ ​`,
    image: "/images/media/thoughtshop.jpg",
    link: "#",
  },
  {
    title: "Millennium Post",
    text: `Over the last two decades, Millennium Post has been playing a key role in forming
opinions among the English readers in our country. Along with a daily newspaper, it has
a very lively online portal too, which is always on its toes. ​ ​`,
    image: "/images/media/millenium_post.jpg",
    link: "https://www.millenniumpost.in/",
  },

  // {
  //   title: "Thoughtshop",
  //   text: `Thotshop fosters intellectual growth through debates, discussions, and published works, empowering students to voice their thoughts and contribute meaningfully to the global dialogue.`,
  //   image: "/images/media/thoughtshop.jpg",
  //   link: "https://thotshop.in/",
  // },

];


export default function MediaSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(null);

  const changeBG = (index) => {
    if (index === activeIndex) return;

    setNextIndex(index);

    setTimeout(() => {
      setActiveIndex(index);
      setNextIndex(null);
    }, 600);
  };

  const activeItem = mediaItems[activeIndex];
  const nextItem =
    nextIndex !== null ? mediaItems[nextIndex] : null;

  return (
    <section className="media-wrapper">

      <div className="media-top">
        <h2>Media</h2>

        <a href="/media" className="learn-more">
          <i className="bi bi-arrow-right-circle-fill"></i>
          Learn more
        </a>
      </div>

      <div className="media-section">

        <div
          className="media-bg"
          style={{
            backgroundImage: `url(${activeItem.image})`,
          }}
        />

        {nextItem && (
          <div
            className="media-bg media-bg-next"
            style={{
              backgroundImage: `url(${nextItem.image})`,
            }}
          />
        )}

        <div className="overlay"></div>

        <div className="media-inner container">

          <div className="media-menu">
            {mediaItems.map((item, i) => (
              <div
                key={i}
                className={`media-menu-item ${activeIndex === i ? "active" : ""}`}
                onMouseEnter={() => changeBG(i)}
              >
                {item.title}
              </div>
            ))}
          </div>

          <div className="media-content">
            <h3>{activeItem.title}</h3>

            <div className="media-text-box">
              <p>{activeItem.text}</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
